import { API_URL } from "../../constants/app";
import { headersJsonToken, headersFormDataToken, headersToken } from "./requestHeaders";

export async function getUsers(payload) {
	let res = await fetch(`${API_URL}/user/list`, {
		method: "POST",
		headers: headersJsonToken(),
		body: JSON.stringify(payload),
	})
		.then((res) => res.json())
		.then((data) => {
			let modifiedData = [];
			data.body.data.forEach((user, i) => {
				const dateParts = user.createdDate?.split(" ")
				const modifiedParts = user.modifiedDate?.split(" ") || undefined
		
				const createdDate = dateParts[0]
				const createdTime = dateParts[1]
				const modifiedDate = modifiedParts?.length ? modifiedParts[0] : undefined 
				const modifiedTime = modifiedParts?.length ? modifiedParts[1] : undefined 
				modifiedData.push({
					n: i + 1,
					id: user.id,
					value: user.id,
					fullName: user.fullName,
					employeeName: user.fullName,
					username: user.username,
					label: user.username,
					createdBy: user.createdBy,
					createdTime: createdTime,
					createdDate: createdDate,
					modifiedBy: user.modifiedBy,
					modifiedDate: modifiedDate,
					modifiedTime: modifiedTime,
					role: user.userRoleList.map((role) => ({
						...role,
						value: role.id,
						label: role.name,
					})),
				});
			});
			return modifiedData;
		});

	return res;
}
export async function findUser(payload) {
	let res = await fetch(`${API_URL}/user/find/${payload}`, {
		method: "POST",
		headers: headersJsonToken(),
	})
		.then((res) => res.json())
		.then((data) => {
			let modifiedData = [];
			let user = data.body.data[0];
			modifiedData = {
				id: user.id,
				fullName: user.fullName,
				username: user.username,
				signatories: `${API_URL}${user.signature}`,
				employeeId: { value: user.employeeId, label: user.employeeName },
				role: user.userRoleList.map((user) => ({
					...user,
					value: user.id,
					label: user.name,
				})),
			};
			return modifiedData;
		});

	return res;
}

export async function addUser(payload) {
	let res = await fetch(`${API_URL}/user/add`, {
		method: "POST",
		headers: headersFormDataToken(),
		body: payload,
	})
		.then((res) => res.json())
		.then((data) => {
			return data;
		});
	return res;
}
export async function editUser(payload) {
	let res = await fetch(`${API_URL}/user/update`, {
		method: "POST",
		headers: headersFormDataToken(),
		body: payload,
	})
		.then((res) => res.json())
		.then((data) => {
			return data;
		});
	return res;
}
export async function deleteUser(id) {
	let res = await fetch(`${API_URL}/user/delete/${id}`, {
		method: "POST",
		headers: headersToken(),
	})
		.then((res) => res.json())
		.then((data) => {
			return data;
		});
	return res;
}
export async function changePasswordUser(formData) {
	let res = await fetch(`${API_URL}/user/change-password`, {
		method: "POST",
		headers: headersToken(),
		body: formData,
	})
		.then((res) => res.json())
		.then((data) => {
			return data;
		});
	return res;
}

export async function importUser(formData) {
	let res = await fetch(`${API_URL}/import-excel/user`, {
		method: "POST",
		headers: headersFormDataToken(),
		body: formData,
	})
		.then((res) => res.json())
		.then((data) => {
			return data;
		});
	return res;
}

